import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { SalonMonsterLoadMaskModule } from '../smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../smr-tap-retry/smr-tap-retry.module';
import { ClientBookingsComponent } from './client-bookings.component';
import { SalonMonsterBookingItemModule } from '../smr-booking-item/smr-booking-item.module';
import { CommonModule } from '@angular/common'; 

import { RouterModule } from '@angular/router';
@NgModule({
    declarations: [
        ClientBookingsComponent
    ],
    imports: [
        IonicModule,
        SalonMonsterLoadMaskModule,
        SalonMonsterBookingItemModule,
        SalonMonsterTapRetryModule,
        CommonModule,
        RouterModule
    ],
    exports: [
        ClientBookingsComponent
    ],
    providers: []
})
export class ClientBookingsModule {}
